import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { MEMORIES } from "@/data/content";
import { Reveal, SectionHeading } from "./Reveal";
import { InlineCta } from "./InlineCta";

const MemoryCard = ({ m, i }) => (
  <Reveal delay={(i % 3) * 0.1} className={i % 3 === 1 ? "lg:translate-y-16" : ""}>
    <motion.figure
      data-testid={`memory-card-${i + 1}`}
      style={{ rotate: m.rotate }}
      whileHover={{ rotate: 0, y: -8, scale: 1.015 }}
      transition={{ type: "spring", stiffness: 220, damping: 20 }}
      className="group rounded-[1.75rem] bg-white p-3 pb-5 shadow-[0_24px_60px_-30px_rgba(18,52,90,0.45)]"
    >
      <div className="relative overflow-hidden rounded-[1.3rem]">
        <img src={m.image} alt={`Sample memory: ${m.title}`} loading="lazy" width="800" height="800" className="aspect-[4/3] w-full object-cover transition-transform duration-1000 ease-out group-hover:scale-105" />
        <span className="absolute left-3 top-3 rounded-full bg-cream/95 px-3 py-1 text-xs font-bold text-navy backdrop-blur">{m.kind}</span>
        <span className="absolute right-3 top-3 rounded-full bg-navy/85 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-cream">Sample</span>
      </div>
      <figcaption className="px-3 pt-5">
        <div className="flex items-baseline justify-between gap-3">
          <h3 className="font-heading text-xl font-extrabold text-navy">{m.title}</h3>
        </div>
        <p className="mt-1 text-sm font-semibold text-teal-dark">{m.child}</p>
        <p className="mt-3 text-[15px] leading-relaxed text-navy/75">{m.note}</p>
      </figcaption>
    </motion.figure>
  </Reveal>
);

export const Gallery = () => (
  <section id="memories" aria-labelledby="memories-heading" className="relative overflow-hidden px-5 py-24 sm:px-8 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
        <SectionHeading id="memories-heading" eyebrow="Memories" title="A little collection, beautifully kept." intro="Drawings, school projects and milestone moments—each one saved with the story that makes it theirs." />
        <Reveal delay={0.2}>
          <p data-testid="gallery-demo-notice" className="flex max-w-xs items-start gap-2.5 rounded-2xl border border-navy/15 bg-white/70 p-4 text-sm leading-relaxed text-navy/80">
            <Info className="mt-0.5 h-4 w-4 shrink-0 text-teal-dark" aria-hidden="true" />
            Illustrative demo content. These are sample memories, not real customer memories.
          </p>
        </Reveal>
      </div>
      <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 lg:gap-10 lg:pb-16">
        {MEMORIES.map((m, i) => <MemoryCard key={m.title} m={m} i={i} />)}
      </div>
      <InlineCta source="gallery" text="Start your own collection when early access opens." />
    </div>
  </section>
);
